export const TRIP_CONFIG = {
    CANCELLED: {
        STATE: 'CANCELLED',
        TYPE: 'cancelled',
    },
    PAST: {
        STATE: 'PAST',
        TYPE: 'past',
    },
    UPCOMING: {
        STATE: 'UPCOMING',
        TYPE: 'upcoming',
    },
};

export const CAN_PAY_PAYMENT_STATUS = {
    NOT_STARTED: true,
    OVERDUE: true,
    PENDING: true,
    SCHEDULED: true,
    SENT: true,
    UNPAID: true,
};
